import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { AppSettings } from "../../config/app-settings.js";
import { masterActions } from "../../_store/master.slice.js";
import { registeredUserActions } from "../../_store/registeredUser.slice.js";
import { matchPath } from "react-router-dom";
import {
  facilityAction,
  managementUserAction,
  messagesAction,
  revenueReportingActions,
  documentsActions,
  publicUserActions,
  authActions,
  photoAction,
  postalMailActions,
  keywordAction,
  inmateAction,
  kiosksActions,
  staffRequestAction,
  dndAction,
  connectionRequestActions,
  reportingAction,
  IpActivityAction,
  noticeAction,
  eCardAction,
} from "../../_store/index.js";
import { PODAction } from "../../_store/pod.slice.js";
import Swal from "sweetalert2";
import { getStoredValue } from "../../_helpers/storagehelper.js";

const Customizesidebar = ({ item, isSubMenu = false }) => {
  const dispatch = useDispatch();
  const pageReload = useSelector((x) => x?.master?.isPageReload);
  const { islogReporttabKey } = useSelector((x) => x?.master);
  const authUser = useSelector((x) => x.auth.user);
  const commonFacilityCode = useSelector((x) => x.auth.commonFacilityCode);
  const inmateMessageCount =
    parseInt(getStoredValue("inmateMessageCount")) || 0;
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(AppSettings);

  // const isChildActive =
  //   location.pathname.startsWith(item?.URLPath) && !item?.children;
  // const isparentActive = item?.children?.some((child) =>
  //   location.pathname.startsWith(child?.URLPath)
  // );

  //for checking the exact match of the URL path
  const isChildActive =
    !item?.children &&
    (matchPath({ path: item?.URLPath, end: true }, location.pathname) ||
      item?.SubMenus?.some((sub) =>
        matchPath({ path: sub.Subpath, end: true }, location.pathname)
      ));

  const isparentActiveMenu = item?.children?.some(
    (child) =>
      matchPath({ path: child.URLPath, end: true }, location.pathname) ||
      child?.SubMenus?.some((sub) =>
        matchPath({ path: sub.Subpath, end: true }, location.pathname)
      )
  );

  // Expand All Menus
  const isparentActive = item?.children?.length > 0 ? true : false;

  // Expand All Menus
  //const [subnav, setSubnav] = useState(isparentActive ? true : false);

  const [subnav, setSubnav] = useState(isparentActiveMenu ? true : false);

  const handlePageLoading = (e, path) => {
    Swal.close();
    if (path !== "") {
      navigate(path);
      context.toggleAppSidebarMobile(e);
      const pageReloading = pageReload + 1;
      dispatch(masterActions?.updateLocation(pageReloading));
    }
    dispatch(masterActions.UpdateisDashboardPage(false));
    dispatch(masterActions.UpdateisBacktoDashboard(false));
    dispatch(masterActions.updateismsgFlagDisabled(false));
    const loggedUser = getStoredValue("user");
    dispatch(authActions?.updateUser(loggedUser));

    switch (item?.URLPath || path) {
      case "/Admin/LogReports":
        const keyUpdate = islogReporttabKey + 1;
        dispatch(masterActions?.updatelogReporttabKey(keyUpdate));
        dispatch(publicUserActions.setLogReportsCurrrentTab("logreport-kiosk-tab"));
        break;

      case "/Admin/RegisteredUserList":
        dispatch(registeredUserActions.resetForm());
        dispatch(registeredUserActions.clearRegisteredPublicUserList());
        break;

      case "/Admin/Reporting":
        dispatch(reportingAction.resetTabActive());
        dispatch(reportingAction.resetreqActivityDataSearch());
        dispatch(reportingAction.resetuserActivityDataSearch());
        break;

      case "/Admin/FacilityList":
        dispatch(facilityAction.resetFacilitySearch());
        break;

      case "/Admin/ManagementUserList":
        dispatch(managementUserAction.resetManagementUserSearchData());
        break;

      case "/Admin/RevenueReport":
        dispatch(revenueReportingActions.resetRevenueReports());
        break;

      case "/Admin/MessageList":
        dispatch(messagesAction.resetMessageSearchData());
        break;

      case "/Admin/PostalMailList":
        dispatch(postalMailActions.clearPostalMail());
        dispatch(postalMailActions.clearSearchPostalMail());
        break;

      case "/Admin/DocumentList":
        dispatch(documentsActions.clearDocuments());
        break;

      case "/Admin/PublicUserList":
        dispatch(publicUserActions.clearpublicUserListSearch());
        break;

      case "/Admin/PhotoList":
        dispatch(photoAction?.resetPhotoState());
        break;

      case "/Admin/KeywordList":
        dispatch(keywordAction.clearSearchKeyword());
        dispatch(keywordAction.resetkeyword());
        break;

      case "/Admin/InmateList":
        dispatch(inmateAction.resetInmateSearchData());
        break;

      case "/Admin/PODList":
        dispatch(PODAction?.resetForm());
        dispatch(PODAction.resetSearchPOD());
        break;

      case "/Admin/StaffRequestList":
        dispatch(staffRequestAction?.resetStaffRequestSearcList());
        dispatch(staffRequestAction?.resetPublicDefenderSearchList());
        dispatch(staffRequestAction?.resetMessageToInmateSearchList());
        dispatch(staffRequestAction?.resetPrivateConversationSearchList());
        break;

      case "/Admin/DNDUserList":
        dispatch(dndAction?.clearDNDSearch());
        break;

      case "/Admin/ConnectionRequestList":
        dispatch(connectionRequestActions?.resetConnectionReqSearchData());
        break;

      case "/Admin/IPActivityList":
        dispatch(IpActivityAction?.resetIPSearch());
        break;

      case "/Admin/KioskList":
        let data = {
          podID: 0,
          kioskCode: "",
          maintenanceStatus: 2,
          activeStatus: 2,
          facilityID: commonFacilityCode,
          pageNo: 1,
          rowCountPerPage: 10,
        };
        dispatch(inmateAction.resetInmateSearchData());
        dispatch(kiosksActions?.setKiosksSearch(data));
        break;

      case "/Admin/NoticeList":
        dispatch(noticeAction.resetNoticeSearch());
        break;

      case "/Admin/E-Cards":
        dispatch(eCardAction.clearECardUploadSearch());
        break;

      case "/Admin/E-Cards/Category":
        dispatch(eCardAction.clearEcardCategorySearch());
        break;

      case "/Admin/E-Cards/Sent":
        dispatch(
          eCardAction.updateSentEcardSearch({
            FacilityID: commonFacilityCode,
            InmateResidentId: "",
            PublicFirstName: "",
            PublicLastName: "",
            InmateFirstName: "",
            InmateLastName: "",
            EcardSubject: "",
            EcardSendStartDate: "",
            EcardSendEndDate: "",
            EcardReadStatus: 0,
            PageNo: 1,
            RowCountPerPage: 10,
            SortBy: "Sentdate DESC",
          })
        );
        break;

      default:
        break;
    }

    const Userdetails = getStoredValue("user");
    const ManagementUserID =
      authUser?.ManagementUserID ?? Userdetails?.ManagementUserID ?? 0;
    const facilityCode =
      parseInt(getStoredValue("commonFacilityCode"), 10) ||
      commonFacilityCode?.FacilityID ||
      0;

    if (Userdetails?.UserRoleID === 10 || Userdetails?.UserRoleID === 11) {
      dispatch(
        masterActions.GetPublicDefenderNotificationAlert({
          ManagementUserID: ManagementUserID,
          FacilityID: facilityCode,
        })
      ).then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      });

      dispatch(
        staffRequestAction?.getInmateMessageCount({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      );
    } else {
      dispatch(
        masterActions.GetLoadNotificationAlert({
          ManagementUserID: ManagementUserID,
          FacilityID: facilityCode,
        })
      ).then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      });

      dispatch(
        staffRequestAction?.getInmateMessageCount({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      );
    }
  };

  let icon = item.CssClassName && (
    <div className="menu-icon">
      <i className={item.CssClassName}></i>
    </div>
  );
  let img = item.img && (
    <div className="menu-icon-img">
      <img src={item.img} alt="" />
    </div>
  );
  let caret = item.children && !item.badge && (
    <div className={`menu-caret ${subnav ? "menu-caret-active" : ""}`}></div>
  );
  let badge = item.badge && <div className="menu-badge">{item.badge}</div>;
  let MenuName = item.MenuName && (
    <div className="menu-text">{item.MenuName}</div>
  );

  let MenuBadge = item.MenuName && (
    // <div className="menu-badge button-success" >
    <div className="menu-badge" style={{ backgroundColor: "#FFC506", color: "black", fontWeight: 'bold' }}>
      {item.NotificationCount +
        (item.ManagementMenuID === 9 ? inmateMessageCount || 0 : 0)}
    </div>
  );

  return (
    <div
      className={
        (!isSubMenu ? "menu-item" : "") +
        (isSubMenu && isChildActive
          ? "menu-item active"
          : isChildActive
            ? " active"
            : "")
      }
    >
      <NavLink
        id={item?.ManagementMenuID}
        className={`menu-link fs-5 menu-link-custom-style ${isparentActiveMenu ? "highlightmenu" : ""
          }`}
        //to={item.URLPath}
        onClick={(e) => {
          if (item?.children) {
            setSubnav(!subnav);
          } else {
            handlePageLoading(e, item.URLPath);
          }
        }}
        onTouchEnd={(e) => {
          if (item?.children) {
            setSubnav(!subnav);
          } else {
            handlePageLoading(e, item.URLPath);
          }
        }}
        onContextMenu={(e) => e.preventDefault()}
      >
        {img} {icon} {MenuName}
        {(item.MenuName === "Staff Requests" && item.ManagementMenuID === 9
          ? item.NotificationCount + (inmateMessageCount || 0) > 0
          : item.NotificationCount > 0) && MenuBadge}
        {caret} {badge}
      </NavLink>

      {subnav && (
        <div className={"menu-submenu"}>
          {item.children.map((submenu, i) => (
            <React.Fragment key={i}>
              <Customizesidebar item={submenu} isSubMenu={true} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default Customizesidebar;
